import useLanguageNavigate from '@hooks/useLanguageNavigate';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const RequestsAndOffers = ({ data }: any) => {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();

	const isFarmerPath = location.pathname.includes('farmer');

	return (
		<div className="grid grid-cols-3 gap-4 max-md:!grid-cols-1 w-full">
			<div className="flex flex-col gap-[20px] pb-5">
				<div
					className="border-t-[9px] border-t-primary rounded-[7px] border border-secondary bg-white min-w-[230px] h-[168px] flex justify-center items-center flex-col transition-all duration-300 ease-in-out cursor-pointer hover:shadow-custom-button hover:-translate-y-2.5"
					onClick={() =>
						navigateWithLanguage(
							`/${isFarmerPath ? 'farmer' : 'specialist'}/monitoring/ongoing-projects`
						)
					}
				>
					<h5 className="text-dark text-center roboto-bold text-[16px] leading-[140%] mb-[7px]">
						{t('monitoring')}
					</h5>
					<ul className="list-disc list-inside">
						<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
							{`${t('requests')} (${data?.services?.monitoring.requests || 0})`}
						</li>
						<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
							{`${t('offer')} (${data?.services?.monitoring.offers || 0})`}
						</li>
					</ul>
				</div>
				<Button
					variant="contained"
					onClick={() =>
						navigateWithLanguage(
							`/${isFarmerPath ? 'farmer' : 'specialist'}/monitoring/ongoing-projects`
						)
					}
				>
					{t('ongoingMonitoring')}
					<span className="ml-[4px]">({data?.services?.monitoring.active || 0})</span>
					<KeyboardArrowRightIcon />
				</Button>
			</div>
			<div
				onClick={() =>
					navigateWithLanguage(`/${isFarmerPath ? 'farmer' : 'specialist'}/express/offers`)
				}
				className="border-t-[9px] border-t-primary rounded-[7px] border border-secondary bg-white min-w-[230px] h-[230px] flex justify-center items-center flex-col transition-all duration-300 ease-in-out cursor-pointer hover:shadow-custom-button hover:-translate-y-2.5"
			>
				<h5 className="text-dark text-center roboto-bold text-[16px] leading-[140%] mb-[7px]">
					{t('express')}
				</h5>
				<ul className="list-disc list-inside">
					<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
						{`${t('requests')} (${data?.services?.express.requests || 0})`}
					</li>
					<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
						{`${t('offer')} (${data?.services?.express.offers || 0})`}
					</li>
					<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
						{`${t('ongoing')} (${data?.services?.express.active || 0})`}
					</li>
				</ul>
			</div>
			<div
				onClick={() =>
					navigateWithLanguage(`/${isFarmerPath ? 'farmer' : 'specialist'}/seasonal-onetime/offers`)
				}
				className="border-t-[9px] border-t-primary rounded-[7px] border border-secondary bg-white min-w-[230px] h-[230px] flex justify-center items-center flex-col transition-all duration-300 ease-in-out cursor-pointer hover:shadow-custom-button hover:-translate-y-2.5"
			>
				<h5 className="text-dark text-center roboto-bold text-[16px] leading-[140%] mb-[7px]">
					{t('requestsAndOffers.oneTimeSeasonal')}
				</h5>
				<ul className="list-disc list-inside">
					<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
						{`${t('requests')} (${data?.services?.seasonal_onetime.requests || 0})`}
					</li>
					<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
						{`${t('offer')} (${data?.services?.seasonal_onetime.offers || 0})`}
					</li>
					<li className="text-secondary  roboto-regular text-[16px] leading-[140%]">
						{`${t('ongoing')} (${data?.services?.seasonal_onetime.active || 0})`}
					</li>
				</ul>
			</div>
		</div>
	);
};
